import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody,
    Form, FormGroup, Label, Input, Button, Row, Col
} from 'reactstrap';
import { CustoContext } from '../../context/CustoContext';
import { CreateCustoType } from '../../context/hooks/useCusto';
import { TipoCustoContext } from '../../context/TipoCustoContext';
import { AuthContext } from '../../context/AuthContext';
import { ContratoContext } from '../../context/ContratoContext';
import Select from "react-select";

interface Props {
    isOpen: boolean;
    toggle: () => void;
    selectedContratoId: number;
}

export const CreateCustoModal: React.FC<Props> = ({
    isOpen,
    toggle,
    selectedContratoId,
}) => {
    const {
        createCusto,
        getCustoFinanceiroPaged,
        getCustoGeralPaged
    } = useContext(CustoContext);

    const {
        listTipoCusto,
        getAllTipoCustoPaged
    } = useContext(TipoCustoContext);

    const { 
        getContratoById 
    } = useContext(ContratoContext);

    const { objUserTk } = useContext(AuthContext);
    const [saldoContrato, setSaldoContrato] = useState(0);
    const [newCusto, setNewCusto] = useState<CreateCustoType>({
        description: '',
        proportionalCurrentStudents: false,
        individualValue: 0,
        currentBalance: 1,
        requestDate: '',
        deliveryDate: '',
        paymentDate: '',
        receiver: '',
        observation: '',
        isPaid: false,
        empresaId: objUserTk.EmpresaId,
        contratoId: selectedContratoId,
        tipoCustoId: 0,
    });

    useEffect(() => {
        if (isOpen) {
            getAllTipoCustoPaged(1, 10000, objUserTk.EmpresaId);
            resetCustoFields();

            getContratoById(selectedContratoId).then(contrato => {
            if (!contrato) return;

            const saldo =
                contrato.currentStudents && contrato.currentStudents > 0
                    ? contrato.currentStudents
                    : contrato.hiredStudents && contrato.hiredStudents > 0
                        ? contrato.hiredStudents
                        : 0;

            setSaldoContrato(saldo);
        });
        }
    }, [isOpen]);

    const formatCustoData = (custo: any) => ({
        ...custo,
        individualValue: Number(custo.individualValue),
        currentBalance: Number(custo.currentBalance),
        requestDate: custo.requestDate ? custo.requestDate : null,
        deliveryDate: custo.deliveryDate ? custo.deliveryDate : null,
        paymentDate: custo.paymentDate ? custo.paymentDate : null,
        isPaid: custo.isPaid === "true" || custo.isPaid === true,
        empresaId: Number(custo.empresaId),
        contratoId: Number(custo.contratoId),
        tipoCustoId: Number(custo.tipoCustoId),
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        setNewCusto(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value === '' ? null : value
        }));
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        try {
            const formattedCusto = formatCustoData(newCusto);
            await createCusto(formattedCusto);
            await getCustoFinanceiroPaged(1, selectedContratoId, objUserTk.EmpresaId, 9);
            await getCustoGeralPaged(1, selectedContratoId, objUserTk.EmpresaId, 9);
            toggle();
        } catch (err) {
            console.error("Erro ao criar custo:", err);
        }
    };

    const handleCancel = () => {
        toggle();
        resetCustoFields();
    };

    const resetCustoFields = () => {
        setNewCusto({
            description: '',
            proportionalCurrentStudents: false,
            individualValue: 0,
            currentBalance: 1,
            requestDate: '',
            deliveryDate: '',
            paymentDate: '',
            receiver: '',
            observation: '',
            isPaid: false,
            empresaId: objUserTk.EmpresaId,
            contratoId: selectedContratoId,
            tipoCustoId: 0,
        });
    };

    const tipoCustoOptions = listTipoCusto.map(tc => ({
        value: tc.id,
        label: tc.description,
    }));

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="xl">
            <ModalHeader toggle={toggle}>Adicionar novo custo</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="input-description">Descrição do custo</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="description"
                                    id="description"
                                    value={newCusto.description}
                                    placeholder="Ex: Material didático, Aluguel de espaço etc..."
                                    onChange={handleInputChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="email">Tipo de custo</Label>
                                <Select
                                    className="form-control-alternative"
                                    classNamePrefix="react-select"
                                    options={tipoCustoOptions}
                                    placeholder="Selecione ou digite para filtrar..."
                                    isClearable

                                    value={
                                        tipoCustoOptions.find(o => o.value === newCusto.tipoCustoId) || null
                                    }

                                    onChange={option => {
                                        const tipoSelecionado = listTipoCusto.find(tc => tc.id === option?.value);
                                        setNewCusto(prev => ({
                                            ...prev,
                                            tipoCustoId: option?.value ?? 0,
                                            individualValue: tipoSelecionado?.value ?? prev.individualValue,
                                            currentBalance: tipoSelecionado?.isFixo ? saldoContrato : 1,
                                        }));
                                    }}

                                    filterOption={(opt, input) =>
                                        opt.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="input-description">
                                    Valor individual
                                </Label>
                                <Input
                                    className="form-control-alternative"
                                    type="number"
                                    name="individualValue"
                                    id="individualValue"
                                    value={newCusto.individualValue}
                                    onChange={handleInputChange}
                                    placeholder="Valor individual do custo"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="1">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="input-description">
                                    Saldo
                                </Label>
                                <Input
                                    className="form-control-alternative"
                                    type="number"
                                    name="currentBalance"
                                    id="currentBalance"
                                    value={newCusto.currentBalance}
                                    onChange={handleInputChange}
                                    placeholder="Saldo"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="input-description">
                                    Data de solicitação
                                </Label>
                                <Input
                                    className="form-control-alternative"
                                    type="date"
                                    name="requestDate"
                                    id="requestDate"
                                    value={newCusto.requestDate?.toString()}
                                    onChange={handleInputChange}
                                    placeholder="Data de solicitação"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="input-description">
                                    Data de entrega
                                </Label>
                                <Input
                                    className="form-control-alternative"
                                    type="date"
                                    name="deliveryDate"
                                    id="deliveryDate"
                                    value={newCusto.deliveryDate?.toString()}
                                    onChange={handleInputChange}
                                    placeholder="Data de entrega"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="input-description">
                                    Data de pagamento
                                </Label>
                                <Input
                                    className="form-control-alternative"
                                    type="date"
                                    name="paymentDate"
                                    id="paymentDate"
                                    value={newCusto.paymentDate?.toString()}
                                    onChange={handleInputChange}
                                    placeholder="Data de pagamento"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="input-description">
                                    Recebedor
                                </Label>
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="receiver"
                                    id="receiver"
                                    value={newCusto.receiver}
                                    onChange={handleInputChange}
                                    placeholder="Recebedor"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="input-description">
                                    Observação
                                </Label>
                                <Input
                                    className="form-control-alternative"
                                    type="textarea"
                                    name="observation"
                                    id="observation"
                                    value={newCusto.observation}
                                    onChange={handleInputChange}
                                    placeholder="Observação"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end mt-4">
                        <Button color="dark" type="submit">Criar custo</Button>
                        <Button color="danger" className="ml-2" onClick={handleCancel}>Cancelar</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};
